"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Comment = void 0;
class Comment {
    constructor(data) {
        this.id = null;
        this.author = null;
        this.content = null;
        this.createdAt = null;
        this.updatedAt = null;
        if (data) {
            this.hydrate(data);
        }
    }
    hydrate(data) {
        this.id = data.id || null;
        this.author = data.author || null;
        this.content = data.content || null;
        this.createdAt = data.createdAt || null;
        this.updatedAt = data.updatedAt || null;
    }
}
exports.Comment = Comment;
//# sourceMappingURL=Comment.js.map